module.exports = __webpack_public_path__ + "static/media/notfound.d6e664e7.gif";